/**
 * Returns true if the given URL targets an S3 endpoint.
 *
 * Matches both classic S3 and S3 Express URL styles:
 *   Virtual-hosted:  bucket.s3.amazonaws.com, bucket.s3.us-east-1.amazonaws.com
 *   Path-style:      s3.amazonaws.com/<bucket>, s3-<region>.amazonaws.com/<bucket>
 *   S3 Express:      bucket--az-id--x-s3.s3express-<zone>.<region>.amazonaws.com
 *
 * Does NOT match other AWS services (SES, Cognito, API Gateway, Lambda) that
 * also end in .amazonaws.com.
 *
 * Hostname-only matching avoids false positives from .s3. appearing in URL
 * path segments (e.g. /report.s3.backup.pdf).
 */
export const isS3Url = (url: string): boolean => {
  try {
    const { hostname } = new URL(url);
    return /(^|\.)s3([.-]|express-)/.test(hostname);
  } catch {
    return false; // relative URLs are never S3 presigned URLs
  }
};
